<template>
  <v-container fluid class="pa-0" grid-list-lg>
    <v-card color="yellow darken-2" class="elevation-10">
      <v-card-title>
        <v-flex xs12 sm4> Purchase </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
        <!-- <v-flex class="shrink">
          <v-btn @click="print" class="ml-1" icon>
            <v-icon>print</v-icon>
            </v-btn>
        </v-flex> -->
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="purchase"
        :loading="loading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :server-items-length="totalItems"
        :search="search"
        :sort-by.sync="sortBy"
        class="elevation-0"
        @pagination="onPagination"
        :footer-props="{
          'items-per-page-options': [10, 15, 25, 50, 100],
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.updatedAt | moment("L") }}</td>
            <td>
              <v-btn
                @click="setOpenSerialSearch(item)"
                text
                icon
                small
                color="primary"
              >
                <v-icon color="green">mdi-feature-search-outline</v-icon>
              </v-btn>
              <span>{{ item.imeiNumber }}</span>
            </td>
            <td>{{ textCapitalize(item.status) }}</td>
            <td class="text-right">{{ item.cost | currency }}</td>
          </tr>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import purchaseService from "@/modules/Inventory/Purchase/service.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "purchase-detail-list",
  props: ["ProductId", "status", "singleStatus"],

  data() {
    return {
      headers: [
        { text: "Created At", value: "date", sortable: true },
        { text: "IMEI Number", value: "imeiNumber", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Cost Price", align: "right", value: "cost", sortable: true },
      ],
      purchase: [],
      totalItems: 0, // ✅ now defined
      search: null,
      loading: false,
      page: 1,
      sortBy: "createdAt",
      itemsPerPage: 10,
    };
  },

  created() {
    this.getList();
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    ...mapActions("layout", ["setOpenSerialSearch", "setOpenRestockSerial"]),
    onPagination(pagination) {
      this.page = pagination.page;
      this.itemsPerPage = pagination.itemsPerPage;
      this.getList();
    },

    textCapitalize(val) {
      return val ? val.charAt(0).toUpperCase() + val.slice(1) : "";
    },

    getList() {
      this.loading = true;

      const options = {
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        search: this.search,
        sortBy: this.sortBy,
      };

      const where = {
        status: this.status,
        singleStatus: this.singleStatus,
        ProductId: this.ProductId,
      };

      purchaseService
        .getSerialVault({ ...where, ...options })
        .then((response) => {
          console.log("getSerialVault", response);
          this.loading = false;
          this.purchase = response.data || [];
          this.totalItems = response.count || this.purchase.length;
        })
        .catch((err) => {
          this.loading = false;
          console.error("Error loading purchase list:", err);
        });
    },
  },
};
</script>
